import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import LoginUtil from "./util/LoginUtil";
import {BASIC_LOGIN, AD_AZURE_LOGIN, TWO_FA_LOGIN} from "./constants/LoginTypes"

Vue.use(Router);

const routes = [
    {
        path: "/successADLogin",
        name: 'successADLogin',
        component: () => import(/* webpackChunkName: "successADLogin" */ "./views/login/ad_azure/SuccessADLogin")
    },
    {
        path: "/",
        component: () => import(/* webpackChunkName: "MediciApp" */ "./views/app/index"),
        redirect: "/home",
        meta: {
            requiresAuth: true
        },
        children: [
            //új
            {
                path: '/home',
                name: 'Home',
                component: () => import(/* webpackChunkName: "Home" */ './views/app/home/Home')
            },
            //administrationMenu
            {
                path: '/administration/laboratoryTypes',
                name: 'LaboratoryTypes',
                component: () => import(/* webpackChunkName: "LaboratoryTypes" */ './views/app/administration/laboratoryTypes/LaboratoryTypes'),
                meta: {
                    resetStateArray: [
                        'laboratoryTypes/resetState',
                    ]
                }
            },
            {
                path: '/administration/treatmentTypes',
                name: 'TreatmentTypes',
                component: () => import(/* webpackChunkName: "TreatmentTypes" */ './views/app/administration/treatmentTypes/TreatmentTypesView'),
                meta: {
                    resetStateArray: [
                        'treatmentType/resetState',
                    ]
                }
            },
            {
                path: 'administration/medicalTemplates',
                name: 'MedicalTemplates',
                component: () => import(/* webpackChunkName: "MedicalTemplates" */ './views/app/administration/medicalTemplates/MedicalTemplatesView'),
                meta: {
                    resetStateArray: [
                        'doctorTemplate/resetState'
                    ]
                }
            },
            {
                path: '/administration/consultingHours',
                name: 'ConsultingHours',
                component: () => import(/* webpackChunkName: "ConsultingHours" */ './views/app/administration/consultingHours/ConsultingHoursView'),
                meta: {
                    resetStateArray: [
                        'doctorConsultConfig/resetState'
                    ]
                }
            },
            {
                path: '/administration/patients',
                name: 'Patients',
                component: () => import(/* webpackChunkName: "Patients" */ './views/app/administration/patients/PatientsView'),
                meta: {
                    resetStateArray: [
                        'patient/resetState'
                    ]
                }
            },
            {
                path: '/administration/personnel',
                name: 'Personnel',
                component: () => import(/* webpackChunkName: "Personnel" */ './views/app/administration/personnel/PersonnelView'),
                meta: {
                    resetStateArray: [
                        'doctor/resetState',
                        'humanResource/resetState',
                        'staff/resetState',
                    ]
                }
            },
            {
                path: '/administration/rooms',
                name: 'Rooms',
                component: () => import(/* webpackChunkName: "Rooms" */ './views/app/administration/rooms/RoomsView'),
                meta: {
                    resetStateArray: [
                        'room/resetState',
                    ]
                }
            },
            {
                path: '/administration/roomDevices',
                name: 'DeviceAndRoomAssignment',
                component: () => import(/* webpackChunkName: "DeviceAndRoomAssignment" */ './views/app/administration/deviceAndRoomAssignment/DeviceAndRoomAssignment'),
                meta: {
                    resetStateArray: [
                        'deviceAndRoomAssignment/resetState',
                    ]
                }
            },
            {
                path: '/administration/mergingPatients',
                name: 'MergingPatients',
                component: () => import(/* webpackChunkName: "MergingPatients" */ './views/app/administration/mergingPatients/MergingPatients'),
                meta: {
                    resetStateArray: [
                        'mergingPatients/resetState'
                    ]
                }
            },
            {
                path: '/administration/excelImports',
                name: 'AdministrationExcelImports',
                component: () => import(/* webpackChunkName: "MergingPatients" */ './views/app/administration/excelImports/AdmininstrationExcelImports'),
                // meta: {
                //     resetStateArray: [
                //         'mergingPatients/resetState'
                //     ]
                // }
            },
            {
                path: '/administration/otherExaminationDocumentType',
                name: 'OtherExaminationDocumentType',
                component: () => import(/* webpackChunkName: "OtherExaminationDocumentType" */ './views/app/administration/otherExaminationDocumentType/OtherExaminationDocumentType'),
                meta: {
                    resetStateArray: [
                        'otherExaminationDocumentType/resetState'
                    ]
                }
            },
            {
                path: '/administration/healthInsurancePartner',
                name: 'HealthInsurancePartners',
                component: () => import(/* webpackChunkName: "HealthInsurancePartners" */ './views/app/administration/healthInsurancePartner/HealthInsurancePartnersView'),
                meta: {
                    resetStateArray: [
                        'healthInsurancePartner/resetState'
                    ]
                }
            },
            //backofficeMenu
            {
                path: '/backoffice/insurancePartners',
                name: 'InsurancePartners',
                component: () => import(/* webpackChunkName: "InsurancePartners" */ './views/app/backoffice/insurancePartners/InsurancePartners.vue'),
                meta: {
                }
            },
            {
                path: '/backoffice/invoiceList',
                name: 'InvoiceList',
                component: () => import(/* webpackChunkName: "InvoiceList" */ './views/app/backoffice/invoiceList/InvoiceListView')
            },
            {
                path: '/backoffice/createInvoice',
                name: 'CreateInvoice',
                component: () => import(/* webpackChunkName: "CreateInvoice" */ './views/app/backoffice/createInvoice/CreateInvoiceView'),
                meta: {
                    resetStateArray: [
                        'invoiceTreatment/resetState'
                    ]
                }
            },
            {
                path: '/backoffice/packages',
                name: 'Packages',
                component: () => import(/* webpackChunkName: "Packages" */ './views/app/backoffice/packages/PackagesView'),
                meta: {
                    resetStateArray: [
                        'packages/resetState',
                        'deletablePackages/resetState'
                    ]
                }
            },
            {
                path: '/backoffice/codedInvoiceItems',
                name: 'CodedInvoiceItems',
                component: () => import(/* webpackChunkName: "CodedInvoiceItems" */ './views/app/backoffice/codedInvoiceItems/CodedInvoiceItems'),
            },
            {
                path: '/backoffice/contracts',
                name: 'Contracts',
                component: () => import(/* webpackChunkName: "Contracts" */ './views/app/backoffice/contracts/ContractsView'),
                meta: {
                    resetStateArray: [
                        'contracts/resetState'
                    ]
                }
            },
            {
                path: '/backoffice/discounts',
                name: 'Discounts',
                component: () => import(/* webpackChunkName: "Discounts" */ './views/app/backoffice/discounts/Discounts'),
                meta: {
                    resetStateArray: [
                        'discounts/resetState'
                        ]
                }
            },
            {
                path: '/backoffice/exchangeRate',
                name: 'ExchangeRate',
                component: () => import(/* webpackChunkName: "ExchangeRate" */ './views/app/backoffice/exchangeRate/ExchangeRate'),
                meta: {
                    resetStateArray: [
                    ]
                }
            },
            {
                path: '/backoffice/otherBillableItems',
                name: 'OtherBillableItems',
                component: () => import(/* webpackChunkName: "OtherBillableItems" */ './views/app/backoffice/otherBillableItems/OtherBillableItems'),
                meta: {
                    resetStateArray: [
                        'otherBillableItems/resetState'
                    ]
                }
            },
            {
                path: '/backoffice/priceLists',
                name: 'PriceListsView',
                component: () => import(/* webpackChunkName: "PriceListsView" */ './views/app/backoffice/priceLists/PricelListsView.vue'),
                meta: {
                    resetStateArray: [
                        'priceList/resetState',
                        'laboratoryTypesPriceList/resetState'
                    ]
                }
            },
            
            {
                path: '/backoffice/customerList',
                name: 'CustomerList',
                component: () => import(/* webpackChunkName: "Packages" */ './views/app/backoffice/customerList/CustomerList'),
                meta: {
                    resetStateArray: [
                        'basicCustomerList/resetState'
                    ]
                }
            },
            {
                path: '/backoffice/proformaInvoice',
                name: 'ProformaInvoice',
                component: () => import(/* webpackChunkName: "ProformaInvoice" */ './views/app/backoffice/proformaInvoice/ProformaInvoice.vue'),
                meta: {
                    resetStateArray: [
                        'proformaInvoice/resetState'
                    ]
                }
            },

            //eesztAdministrationMenu
            {
                path: '/eesztAdministration/eesztLogins',
                name: 'EESZTLogins',
                component: () => import(/* webpackChunkName: "EESZTLogins" */ './views/app/eesztAdministration/eesztLogins/EESZTLoginsView')
            },
            {
                path: '/eesztAdministration/eesztTor',
                name: 'EESZTTor',
                component: () => import(/* webpackChunkName: "EESZTTor" */ './views/app/eesztAdministration/eesztTor/EESZTTorView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            //gdprMenu
            {
                path: '/gdpr/dataTransferEvent',
                name: 'DataTransferEvent',
                component: () => import(/* webpackChunkName: "DataTransferEvent" */ './views/app/gdpr/dataTransferEvent/DataTransferEventView'),
                meta: {
                    resetStateArray: [
                        'dataTransferEvent/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/dataHandlingProcess',
                name: 'DataHandlingProcess',
                component: () => import(/* webpackChunkName: "DataHandlingProcess" */ './views/app/gdpr/dataHandlingProcess/DataHandlingProcessView'),
                meta: {
                    resetStateArray: [
                        'dataManagementProcess/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/dataAssetInventory',
                name: 'DataAssetInventory',
                component: () => import(/* webpackChunkName: "DataAssetInventory" */ './views/app/gdpr/dataAssetInventory/DataAssetInventoryView'),
                meta: {
                    resetStateArray: [
                        'dataAssetInventory/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/eventRegistration',
                name: 'EventRegistration',
                component: () => import(/* webpackChunkName: "EventRegistration" */ './views/app/gdpr/eventRegistration/EventRegistrationView'),
                meta: {
                    resetStateArray: [
                        'eventRegistration/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/persons',
                name: 'GDPRPersons',
                component: () => import(/* webpackChunkName: "GDPRPersons" */ './views/app/gdpr/gdprPersons/GDPRPersonsView'),
                meta: {
                    resetStateArray: [
                        'gdprPerson/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/impactAssessment',
                name: 'ImpactAssessment',
                component: () => import(/* webpackChunkName: "ImpactAssessment" */ './views/app/gdpr/impactAssessment/ImpactAssessmentView'),
                meta: {
                    resetStateArray: [
                        'impactAssessment/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/incidentRegister',
                name: 'IncidentRegister',
                component: () => import(/* webpackChunkName: "IncidentRegister" */ './views/app/gdpr/incidentRegister/IncidentRegisterView'),
                meta: {
                    resetStateArray: [
                        'incidentRegistration/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/legalBasis',
                name: 'LegalBasis',
                component: () => import(/* webpackChunkName: "LegalBasis" */ './views/app/gdpr/legalBasis/LegalBasisView'),
                meta: {
                    resetStateArray: [
                        'plea/resetState'
                    ]
                }
            },
            {
                path: '/gdpr/storageLocation',
                name: 'StorageLocation',
                component: () => import(/* webpackChunkName: "StorageLocation" */ './views/app/gdpr/storageLocation/StorageLocationView'),
                meta: {
                    resetStateArray: [
                        'dataManagementProcessPlace/resetState'
                    ]
                }
            },
            //historyMenu
            {
                path: '/histories/eesztLoginHistory',
                name: 'EESZTLoginHistory',
                component: () => import(/* webpackChunkName: "EESZTLoginHistory" */ './views/app/history/eesztLoginHistory/EESZTLoginHistoryView'),
                meta: {
                    resetStateArray: [
                        'eesztLogins/resetState',
                    ]
                }
            },
            {
                path: '/histories/loginHistory',
                name: 'LoginHistory',
                component: () => import(/* webpackChunkName: "LoginHistory" */ './views/app/history/loginHistory/LoginView'),
                meta: {
                    resetStateArray: [
                        'logins/resetState'
                    ]
                }
            },
            {
                path: '/histories/documentLog',
                name: 'DocumentLog',
                component: () => import(/* webpackChunkName: "DocumentLog" */ './views/app/history/documentLog/DocumentLogView'),
                meta: {
                    resetStateArray: [
                        'documentLog/resetState'
                    ]
                }
            },
            {
                path: '/histories/eesztLog',
                name: 'EESZTLog',
                component: () => import(/* webpackChunkName: "EESZTLog" */ './views/app/history/eesztLog/EESZTLogView'),
                meta: {
                    resetStateArray: [
                        'eesztLog/resetState',
                    ]
                }
            },
            {
                path: '/histories/appointmentBookingHistory',
                name: 'AppointmentBookingHistory',
                component: () => import(/* webpackChunkName: "AppointmentBookingHistory" */ './views/app/history/appointmentBookingHistory/AppointmentBookingHistoryView'),
                meta: {
                    resetStateArray: [
                        'appointmentHistory/resetState'
                    ]
                }
            },
            {
                path: '/histories/occupationalHealthAppointmentBookingHistory',
                name: 'OccupationalHealthAppointmentBookingHistory',
                component: () => import(/* webpackChunkName: "OccupationalHealthAppointmentBookingHistory" */ './views/app/history/occupationalHealthAppointmentBookingHistory/OccupationalHealthAppointmentBookingHistoryView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/histories/medicamentArchives',
                name: 'MedicamentArchives',
                component: () => import(/* webpackChunkName: "MedicamentArchives" */ './views/app/history/medicamentArchives/MedicamentArchivesView'),
                meta: {
                    resetStateArray: [
                        'bnoArchive/resetState',
                        'drugBnoArchive/resetState',
                        'drugEquivArchive/resetState',
                        'drugArchive/resetState',
                    ]
                }
            },
            {
                path: '/histories/medio-log',
                name: 'MedioLogHistory',
                component: () => import(/* webpackChunkName: "MedioLogHistory" */ './views/app/history/medioLogHistory/MedioLogView'),
                meta: {}
            },
            {
                path: '/histories/puphaxHistory',
                name: 'PUPHAXHistory',
                component: () => import(/* webpackChunkName: "PUPHAXHistory" */ './views/app/history/puphaxHistory/PUPHAXHistoryView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/histories/occupationalHealthImportHistory',
                name: 'OccupationalHealthImportHistory',
                component: () => import(/* webpackChunkName: "OccupationalHealthImportHistory" */ './views/app/history/occupationalHealthImportHistory/OccupationalHealthImportHistoryView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/histories/emailHistory',
                name: 'EmailHistory',
                component: () => import(/* webpackChunkName: "EmailsHistory" */ './views/app/history/emailHistory/EmailHistoryView'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: '/histories/laboratoryHistory',
                name: 'LaboratoryHistory',
                component: () => import(/* webpackChunkName: "LaboratoryHistory" */ './views/app/history/laboratoryHistory/LaboratoryHistoryView'),
                meta: {
                    resetStateArray: [
                        'labHandleHistory/resetState',
                    ]
                }
            },
            {
                path: 'histories/clinicalEvidenceHistory',
                name: 'ClinicalEvidenceHistory',
                component: () => import(/* webpackChunkName: "ClinicalEvidenceHistory" */ './views/app/history/clinicalEvidenceHistory/ClinicalEvidenceHistoryView'),
                meta: {
                    resetStateArray: [
                        'patientEvidenceHistory/resetState',
                    ]
                }
            },
            {
                path: '/histories/patientHistory',
                name: 'PatientHistory',
                component: () => import(/* webpackChunkName: "PatientHistory" */ './views/app/history/patientHistory/PatientHistoryView'),
                meta: {
                    resetStateArray: [
                        'patientHistory/resetState',
                    ]
                }
            },
            //itAdministrationMenu
            {
                path: '/itAdministration/bno',
                name: 'BNO',
                component: () => import(/* webpackChunkName: "BNO" */ './views/app/itAdministration/bno/BNOView'),
                meta: {
                    resetStateArray: [
                        'bno/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/covid19RAT',
                name: 'Covid19RAT',
                component: () => import(/* webpackChunkName: "Covid19RAT" */ './views/app/itAdministration/covid19RAT/Covid19RATView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: [
                        'covidRAT/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/generalDocumentTemplate',
                name: 'GeneralDocumentTemplate',
                component: () => import(/* webpackChunkName: "GeneralDocumentTemplate" */ './views/app/itAdministration/generalDocumentTemplate/GeneralDocumentTemplateView'),
                meta: {
                    resetStateArray: [
                        'generalDocumentTemplate/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/eesztPostSubmission',
                name: 'EESZTPostSubmission',
                component: () => import(/* webpackChunkName: "EESZTPostSubmission" */ './views/app/itAdministration/eesztPostSubmission/EESZTPostSubmissionView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/itAdministration/emailTemplateEditor',
                name: 'EmailTemplateEditor',
                component: () => import(/* webpackChunkName: "EmailTemplateEditor" */ './views/app/itAdministration/emailTemplateEditor/EmailTemplateEditorView'),
                meta: {
                    resetStateArray: [
                        'emailTemplateEditor/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/user',
                name: 'User',
                component: () => import(/* webpackChunkName: "User" */ './views/app/itAdministration/user/UserView'),
                meta: {
                    resetStateArray: [
                        'user/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/pupha',
                name: 'PUPHA',
                component: () => import(/* webpackChunkName: "PUPHA" */ './views/app/itAdministration/pupha/PUPHAView'),
                meta: {
                    resetStateArray: [
                        'drug/resetState',
                        'drugBno/resetState',
                        'drugEquiv/resetState',
                    ]
                }
            },
            {
                path: '/itAdministration/puphaUpdate',
                name: 'PUPHAUpdate',
                component: () => import(/* webpackChunkName: "PUPHAUpdate" */ './views/app/itAdministration/puphaUpdate/PUPHAUpdateView'),
                meta: {
                    resetStateArray: [
                        'drugStrain/resetState',
                    ]
                }
            },
            {
                path: '/itAdministration/puphax',
                name: 'PUPHAX',
                component: () => import(/* webpackChunkName: "PUPHAX" */ './views/app/itAdministration/puphax/PUPHAXView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: [
                        'drugPuphax/resetState'
                    ]
                }
            },
            {
                path: '/itAdministration/organizationUnit',
                name: 'OrganizationUnit',
                component: () => import(/* webpackChunkName: "OrganizationUnit" */ './views/app/itAdministration/organizationUnit/OrganizationUnitView'),
                meta: {
                    resetStateArray: [
                        'organizationUnit/resetState'
                    ]
                }
            },
            //medicalAttendanceMenu
            {
                path: '/medicalAttendance/covid19',
                name: 'Covid19',
                component: () => import(/* webpackChunkName: "Covid19" */ './views/app/medicalAttendance/covid19/Covid19View')
            },
            {
                path: '/medicalAttendance/eesztResend',
                name: 'EESZTResend',
                component: () => import(/* webpackChunkName: "EESZTResend" */ './views/app/medicalAttendance/eesztResend/EESZTResendView'),
                meta: {
                    resetStateArray: [
                        'eesztResend/resetState'
                    ]
                }
            },
            {
                path: '/medicalAttendance/myReservations',
                name: 'MyReservations',
                component: () => import(/* webpackChunkName: "MyReservations" */ './views/app/medicalAttendance/myReservations/MyReservationsView')
            },
            {
                path: '/medicalAttendance/appointmentBooking',
                name: 'AppointmentBooking',
                component: () => import(/* webpackChunkName: "AppointmentBooking" */ './views/app/medicalAttendance/appointmentBooking/AppointmentBookingView'),
                meta: {
                    resetStateArray: [
                        'appointment/resetState',
                        'patientAttendanceAppointment/resetState',
                    ]
                }
            },
            {
                path: '/medicalAttendance/laboratory',
                name: 'Laboratory',
                component: () => import(/* webpackChunkName: "Laboratory" */ './views/app/medicalAttendance/laboratory/LaboratoryView'),
                meta: {
                    resetStateArray: [
                        'labHandle/resetState',
                    ]
                }
            },
            {
                path: '/medicalAttendance/additionalExamination',
                name: 'AdditionalExamination',
                component: () => import(/* webpackChunkName: "AdditionalExamination" */ './views/app/medicalAttendance/additionalExamination/AdditionalExaminationView'),
                meta: {
                    resetStateArray: [
                        'additionalExamination/resetState',
                    ]
                }
            },
            {
                path: '/medici/patientAttendance',
                name: 'PatientAttendance',
                component: () => import(/* webpackChunkName: "PatientAttendance" */ './views/app/medicalAttendance/patientAttendance/PatientAttendanceView'),
                meta: {
                    resetStateArray: [
                        'patientAttendanceAppointment/resetState',
                        'specialistRecommendation/resetState',
                        'ehr/resetState',
                        'ebeutalo/resetState',
                        'ekatalogus/resetState',
                        'eprofileAktGyogy/resetState',
                        'eprofileAktProblemak/resetState',
                        'eprofileAllergia/resetState',
                        'eprofileAutonomia/resetState',
                        'eprofileEletmod/resetState',
                        'eprofileImplantatum/resetState',
                        'eprofileKorabbiMutet/resetState',
                        'eprofileLezartProblemak/resetState',
                        'eprofileNemAllergia/resetState',
                        'eprofileTerapia/resetState',
                        'eprofileTerhesseg/resetState',
                        'eprofileVedooltasok/resetState',
                        'eprofileVercsoport/resetState',
                        'employabilityOpinion/resetState',
                        'employability/resetState',
                        'medicalRecordSheet/resetState',
                        'additionalExamination/resetState',
                        'occupationHealthFirearmPermit/resetState',
                        'occupationHealthDriverLicense/resetState'
                    ]
                }
            },
            {
                path: '/medicalAttendance/patientWaiting',
                name: 'patientWaiting',
                component: () => import(/* webpackChunkName: "patientWaiting" */ './views/app/medicalAttendance/waitingList/patientWaiting'),
                meta: {
                    resetStateArray: [
                        'patientWaiting/resetState',
                    ]
                }
            },
            {
                path: '/medici/appointmentInpatient',
                name: 'AppointmentInpatient',
                component: () => import(/* webpackChunkName: "AppointmentInpatient" */ './views/app/medicalAttendance/appointmentInpatient/AppointmentInpatientView')
            },
            //occupationalHealthAdministrationMenu
            {
                path: '/occupationalHealthAdministration/exposuresAndProtocols',
                name: 'ExposuresAndProtocols',
                component: () => import(/* webpackChunkName: "ExposuresAndProtocols" */ './views/app/occupationalHealthAdministration/exposuresAndProtocols/ExposuresAndProtocolsView'),
                meta: {
                    resetStateArray: [
                        'occupationHealthExposure/resetState'
                    ]
                }
            },
            {
                path: '/occupationalHealthAdministration/occupationalHealthReferrals',
                name: 'OccupationalHealthReferrals',
                component: () => import(/* webpackChunkName: "OccupationalHealthReferrals" */ './views/app/occupationalHealthAdministration/occupationalHealthReferrals/OccupationalHealthReferrals'),
                meta: {
                    resetStateArray: [
                        'occupationHealthReferral/resetState'
                    ]
                }
            },
            // {
            //     path: '/occupationalHealthAdministration/occupationalHealthPatientImport',
            //     name: 'OccupationalHealthPatientsImport',
            //     component: () => import(/* webpackChunkName: "OccupationalHealthPatientImport" */ './views/app/occupationalHealthAdministration/occupationalHealthPatientImport/OccupationalHealthPatientImportView'),
            //     meta: {
            //         requiresAuth: true,
            //         resetStateArray: []
            //     }
            // },
            {
                path: '/occupationalHealthAdministration/occupationalHealthPatientImport',
                name: 'ExcelImports',
                component: () => import(/* webpackChunkName: "excelImports" */ './views/app/occupationalHealthAdministration/excelImports/ExcelImportsView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: [
                        'feuImport/resetState'
                    ]
                }
            },
            {

                path: '/occupationalHealthAdministration/employabilityTemplates',
                name: 'EmployabilityTemplates',
                component: () => import(/* webpackChunkName: "EmployabilityTemplates" */ './views/app/occupationalHealthAdministration/employabilityTemplates/EmployabilityTemplatesView'),
                meta: {
                    resetStateArray: [
                        'employabilityDoctorTemplate/resetState'
                    ]
                }
            },
            {
                path: '/occupationalHealthAdministration/occupationalHealthAppointmentBooking',
                name: 'OccupationalHealthAppointmentBooking',
                component: () => import(/* webpackChunkName: "OccupationalHealthAppointmentBooking" */ './views/app/occupationalHealthAdministration/occupationalHealthAppointmentBooking/OccupationalHealthAppointmentBookingView')
            },
            {
                path: '/occupationalHealthAdministration/restrictions',
                name: 'Restrictions',
                component: () => import(/* webpackChunkName: "Restrictions" */ './views/app/occupationalHealthAdministration/restrictions/RestrictionsView'),
                meta: {
                    resetStateArray: [
                        'occupationHealthRestriction/resetState'
                    ]
                }
            },
            {
                path: '/occupationalHealthAdministration/restrictionsAndVaccinationImport',
                name: 'RestrictionsAndVaccinationImport',
                component: () => import(/* webpackChunkName: "RestrictionsAndVaccinationImport" */ './views/app/occupationalHealthAdministration/restrictionsAndVaccinationImport/RestrictionsAndVaccinationImportView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/occupationalHealthAdministration/occupationalHealthPartners',
                name: 'OccupationalHealthPartners',
                component: () => import(/* webpackChunkName: "OccupationalHealthPartners" */ './views/app/occupationalHealthAdministration/occupationalHealthPartners/OccupationalHealthPartnersView'),
                meta: {
                }
            },
            {
                path: '/occupationalHealthAdministration/occupationalHealthEmployees',
                name: 'OccupationalHealthEmployees',
                component: () => import(/* webpackChunkName: "OccupationalHealthEmployees" */ './views/app/occupationalHealthAdministration/occupationalHealthEmployees/OccupationalHealthEmployeesView'),
                meta: {
                }
            },
            {
                path: '/occupationalHealthAdministration/vaccination',
                name: 'Vaccination',
                component: () => import(/* webpackChunkName: "Vaccination" */ './views/app/occupationalHealthAdministration/vaccination/VaccinationView'),
                meta: {
                    resetStateArray: [
                        'occupationHealthVaccination/resetState'
                    ]
                }
            },
            {
                path: '/occupationalHealthAdministration/simpleImport',
                name: 'SimpleImport',
                component: () => import(/* webpackChunkName: "SimpleImport" */ './views/app/occupationalHealthAdministration/simpleImport/SimpleImportView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/occupationalHealthAdministration/supervisors',
                name: 'OccupationHealthSupervisors',
                component: () => import(/* webpackChunkName: "OccupationHealthSupervisors" */ './views/app/occupationalHealthAdministration/supervisors/OccupationHealthSupervisorsView'),
                meta: {
                    resetStateArray: [
                        'supervisors/resetState'
                    ]
                }
            },
            //reportMenu
            {
                path: '/reports/patientTrafficReport',
                name: 'PatientTrafficReport',
                component: () => import(/* webpackChunkName: "PatientTrafficReport" */ './views/app/report/patientTrafficReport/PatientTrafficReportView'),
                meta: {
                    resetStateArray: [
                        //'monthlyPremiumForDoctors/resetState',
                        'patientTrafficPerTreatment/resetState',
                        'patientTrafficPerDoctor/resetState',
                    ]
                }
            },
            {
                path: '/reports/eesztReport',
                name: 'EESZTReport',
                component: () => import(/* webpackChunkName: "EESZTReport" */ './views/app/report/eesztReport/EESZTReportView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/reports/occupationalHealthReport',
                name: 'OccupationalHealthReport',
                component: () => import(/* webpackChunkName: "OccupationalHealthReport" */ './views/app/report/occupationalHealthReport/OccupationalHealthReportView'),
                meta: {
                    resetStateArray: [
                        'vaccinationReport/resetState',
                        'occupationHealthlabReport/resetState',
                        'occupationHealthReport/resetState',
                    ]
                }
            },
            {
                path: '/reports/treatmentReport',
                name: 'TreatmentReport',
                component: () => import(/* webpackChunkName: "TreatmentReport" */ './views/app/report/treatmentReport/TreatmentReportView'),
                meta: {
                    resetStateArray: [
                    ]
                }
            },
            {
                path: '/reports/laboratoryReport',
                name: 'LaboratoryReport',
                component: () => import(/* webpackChunkName: "LaboratoryReport" */ './views/app/report/laboratoryReport/LaboratoryReportView'),
                meta: {
                    resetStateArray: [
                    ]
                }
            },
            {
                path: '/reports/doctorReport',
                name: 'DoctorReport',
                component: () => import(/* webpackChunkName: "DoctorReport" */ './views/app/report/doctorReport/DoctorReportView'),
                meta: {
                    resetStateArray: [
                        'monthlyPremiumForDoctors/resetState',
                        'doctorDailyAttendance/resetState',
                    ]
                }
            },
            {
                path: '/reports/partnerReport',
                name: 'PartnerReport',
                component: () => import(/* webpackChunkName: "PartnerReport" */ './views/app/report/partnerReport/PartnerReportView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: []
                }
            },
            {
                path: '/reports/roomReport',
                name: 'RoomReport',
                component: () => import(/* webpackChunkName: "RoomReport" */ './views/app/report/roomReport/RoomReportView'),
                meta: {
                    resetStateArray: [
                    ]
                }
            },
            //serverMenu
            {
                path: '/server/diagnostics',
                name: 'Diagnostics',
                component: () => import(/* webpackChunkName: "Diagnostics" */ './views/app/server/diagnostics/DiagnosticsView')
            },
            {
                path: '/server/hardware',
                name: 'Hardware',
                component: () => import(/* webpackChunkName: "Hardware" */ './views/app/server/hardware/HardwareView')
            },
            {
                path: '/server/networkDiagnostics',
                name: 'NetworkDiagnostics',
                component: () => import(/* webpackChunkName: "NetworkDiagnostics" */ './views/app/server/networkDiagnostics/NetworkDiagnosticsView')
            },
            {
                path: '/server/jvm',
                name: 'JVM',
                component: () => import(/* webpackChunkName: "JVM" */ './views/app/server/jvm/JVMView')
            },
            {
                path: '/server/environment',
                name: 'Environment',
                component: () => import(/* webpackChunkName: "Environment" */ './views/app/server/environment/EnvironmentView')
            },
            {
                path: '/server/liquibaseMetric',
                name: 'LiquibaseMetric',
                component: () => import(/* webpackChunkName: "LiquibaseMetric" */ './views/app/server/liquibaseMetric/LiquibaseMetricView'),
            },
            {
                path: '/server/log',
                name: 'Log',
                component: () => import(/* webpackChunkName: "Log" */ './views/app/server/log/LogView')
            },
            //systemMenu
            {
                path: '/system/extendedCodeStore',
                name: 'ExtendedCodeStore',
                component: () => import(/* webpackChunkName: "ExtendedCodeStore" */ './views/app/system/extendedCodeStore/ExtendedCodeStoreView'),
                meta: {
                    resetStateArray: [
                        'extendedCodeStore/resetState'
                    ]
                }
            },
            {
                path: '/system/company',
                name: 'Company',
                component: () => import(/* webpackChunkName: "Company" */ './views/app/system/company/CompanyView'),
                meta: {
                    resetStateArray: [
                        'company/resetState'
                    ]
                }
            },
            {
                path: '/system/companySite',
                name: 'CompanySite',
                component: () => import(/* webpackChunkName: "CompanySite" */ './views/app/system/companySite/CompanySiteView'),
                meta: {
                    resetStateArray: [
                        'companySite/resetState'
                    ]
                }
            },
            {
                path: '/system/appointmentStatus',
                name: 'AppointmentStatus',
                component: () => import(/* webpackChunkName: "AppointmentStatus" */ './views/app/system/appointmentStatus/AppointmentStatusView'),
                meta: {
                    requiresAuth: true,
                    resetStateArray: [
                        'appointmentStatus/resetState'
                    ]
                }
            },
            {
                path: '/system/roleManagement',
                name: 'RoleManagement',
                component: () => import(/* webpackChunkName: "RoleManagement" */ './views/app/system/roleManagement/RoleManagementView'),
                meta: {
                resetStateArray: [
                    'roleManagement/resetState'
                    ]
                }
            },
            {
                path: '/medici/cancelledAppointments',
                name: 'CancelledAppointments',
                component: () => import(/* webpackChunkName: "CancelledAppointments" */ './views/app/report/patientTrafficReport/patientTrafficReportTabs/CancelledAppointmentsReportView.vue'),

            },
            {
                path: '/system/codeStore',
                name: 'CodeStore',
                component: () => import(/* webpackChunkName: "CodeStore" */ './views/app/system/codeStore/CodeStoreView'),
                meta: {
                    resetStateArray: [
                        'codeStore/resetState'
                    ]
                }
            },
            {
                path: '/system/occupationalHealthCodeStore',
                name: 'OccupationalHealthCodeStore',
                component: () => import(/* webpackChunkName: "OccupationalHealthCodeStore" */ './views/app/system/occupationalHealthCodeStore/OccupationalHealthCodeStoreView'),
                meta: {
                    resetStateArray: [
                        'occupationHealthCodeStore/resetState'
                    ]
                }
            },
            {
                path: '/superAdmin/licenceManagement',
                name: 'LicenceManagement',
                component: () => import(/* webpackChunkName: "LicenceManagement" */ './views/app/system/licenceManagement/LicenceManagementView')
            },
            {
                path: '/system/countryCountyCity',
                name: 'CountryCountyCity',
                component: () => import(/* webpackChunkName: "CountryCountyCity" */ './views/app/system/countryCountyCity/CountryCountyCityView'),
                meta: {
                    resetStateArray: [
                        'countryCountyCity/resetState'
                    ]
                }
            },
            {
                path: '/system/simpleCodeStore',
                name: 'SimpleCodeStore',
                component: () => import(/* webpackChunkName: "SimpleCodeStore" */ './views/app/system/simpleCodeStore/SimpleCodeStoreView'),
                meta: {
                    resetStateArray: [
                        'codeStoreSimple/resetState'
                    ]
                }
            },
            //Hírek menüpont
            {
                path: '/dashboard',
                name: 'DashboardView',
                component: () => import(/* webpackChunkName: "Log" */ './views/app/dashboard/DashboardView')
            },

            //Egyéb
            // {
            //     path: '/medici/instrument',
            //     name: 'Instrument',
            //     component: () => import(/* webpackChunkName: "Instrument" */ './views/app/medici/instrument/InstrumentView'),
            //     meta: {
            //         resetStateArray: [
            //             'instrument/resetState',
            //         ]
            //     }
            // },
            // {
            //     path: '/medici/stock',
            //     name: 'Stock',
            //     component: () => import(/* webpackChunkName: "Stock" */ './views/app/medici/stock/StockView'),
            //     meta: {
            //         resetStateArray: [
            //             'stock/resetState'
            //         ]
            //     }
            // }
        ]
    },
    {
        path: "/login",
        name: 'Login',
        component: () => {
            if (!!store.getters['app/getAppConfig']) {
                switch (store.getters['app/getAppConfig'].loginType) {
                    case BASIC_LOGIN:
                        return import(/* webpackChunkName: "login" */ "./views/login/basic/Login");
                    case AD_AZURE_LOGIN:
                        return import(/* webpackChunkName: "adAzureLogin" */ './views/login/ad_azure/ADAzureLogin');
                    case TWO_FA_LOGIN:
                        return import(/* webpackChunkName: "login2FA" */ './views/login/2fa/TwoFALogin');
                }
            }
        }
    },
    {
        path: "/login2FA",
        name: 'Login2FA',
        component: () => import(/* webpackChunkName: "login2FA" */ "./views/login/2fa/TwoFALogin")
    },
    {
        path: "/loader",
        name: 'loader',
        component: () => import(/* webpackChunkName: "login" */ "./views/login/Loader")
    },
    {
        path: '*',
        name: "error",
        component: () => import(/* webpackChunkName: "error" */ "./views/error/Error")
    },
];

let router = new Router({
    mode: 'history',
    routes: routes
});

router.beforeEach((to, from, next) => {
    if(to.path !== '/loader' && !store.getters['app/getAppConfig']){
        next({name: "loader", params: {path: to} });
        return
    }

    if (to.meta.resetStateArray) {
        to.meta.resetStateArray.forEach(item => {
            store.dispatch(item);
        })
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (LoginUtil.isLoggedIn()) {
            next();
            return
        }

        next('/login')

    } else {
        next()
    }
});

export default router
